import { DISMISS_TOAST, SHOW_TOAST } from 'states/constants';

const initialState = {
  actionContent: '',
  actionHandler: () => {},
  duration: 5000,
  error: false,
  message: 'Successful',
  show: false,
};

export const toastReducer = (state = initialState, action) => {
  switch (action?.type) {
    case SHOW_TOAST:
      return { ...initialState, ...action?.payload };
    case DISMISS_TOAST:
      return { ...initialState, show: false };
    default:
      return state;
  }
};
